import { Component } from "react";

// Error boundary global. Un error en cualquier useQuery/useMutation no debería
// crashear el árbol entero — mostramos algo útil y damos opción de recargar.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary capturó:", error, info);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-bg-main">
        <div className="bg-white rounded-[10px] shadow-card p-8 max-w-lg w-full text-center">
          <div className="text-4xl mb-3">⚠️</div>
          <h1 className="text-xl font-bold text-navy mb-2">Algo salió mal</h1>
          <p className="text-sm text-gray-600 mb-1">
            Una vista del panel falló inesperadamente.
          </p>
          <p className="text-[11px] text-gray-400 mb-5 font-mono break-all">
            {this.state.error?.message || "Error desconocido"}
          </p>
          <div className="flex items-center justify-center gap-3">
            <button
              onClick={() => this.setState({ error: null })}
              className="h-10 px-4 rounded-lg border border-gray-200 text-sm font-semibold text-gray-700 hover:bg-gray-50"
            >
              Reintentar
            </button>
            <button
              onClick={() => window.location.reload()}
              className="h-10 px-4 rounded-lg bg-teal text-white text-sm font-semibold hover:bg-teal/90"
            >
              Recargar página
            </button>
          </div>
        </div>
      </div>
    );
  }
}
